import React, { Component } from 'react';
import classNames from 'classnames';
import { Field } from 'redux-form';
import { Translate, Localize } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem, InputGroup } from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
import InputField from '../Common/inputField';
import IsEnabled from '../Common/isEnabled';
import checkPermission from '../Common/permissions';

class GroupForm extends Component {
  handleFormSubmit(formProps) {
    if (this.props.currentGroup){
      if(!checkPermission("change_product_group"))
        this.props.editGroup(formProps);
      else
        alert("You have no permission!");
    }
    else this.props.createGroup(formProps);
  }

  render() {
    const { handleSubmit, closeG, submitting, pristine, valid } = this.props;
    return (
      <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
        <Row>
          <Col sm={ 6 }>
            <div className="form-group">
              <label><Translate value="group_name"/> (*) </label>
              <Field name="Name" component={ InputField } />
            </div>
          </Col>
          <Col sm = { 3 }>
            <div className="form-group">
              <label><Translate value="description"/></label>
              <Field name="Description" component={ InputField } />
            </div>
          </Col>
        </Row>
        <Field component={ IsEnabled } name="IsEnabled" />
        <br/>
        <br/>
        <button action="submit" className="btn btn-primary buttonStyle" disabled={ submitting || pristine || !valid || !checkPermission("add_product_group") } ><Translate value="submit"/></button>
        <button className="btn btn-danger buttonStyle" onClick={(event) => { event.preventDefault(); closeG(); } } ><Translate value="cancel"/></button>
        { this.props.isCreating || this.props.isEditing && <Spinner/> }
        { this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> }
        { this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError)}</div> }
      </form>
    )
  }
}

export default GroupForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/groupForm.jsx